import{css}from"lit";export default css`
  :host {
    --resize-border: 1px;
    --resize-border-color: var(--md-default-focus-outline-color, #007aa3);
    --area-highlight-color: #00a0d1;
  }

  .container {
    display: grid;
  }
  .container .widget {
    position: relative;
    min-width: 0;
    overflow: hidden;
  }
  .container .widget uuip-dynamic-widget {
    max-width: 100%;
  }
  .container .widget.edit {
    cursor: grab;
  }
  .container .widget.edit .dynamic {
    pointer-events: none;
  }
  .container .widget.drag {
    cursor: move;
  }
  .container .widget.drag-over .resize {
    background-color: var(--area-highlight-color);
  }
  .container .widget.drag-over::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    background-color: rgba(255, 255, 255, 0.3);
  }
  .container .widget .resize {
    position: absolute;
    background-color: var(--resize-border-color);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    transition: background-color 0.15s ease-in-out;
  }
  .container .widget .resize.top {
    cursor: ns-resize;
    bottom: auto;
    height: var(--resize-border);
  }
  .container .widget .resize.bottom {
    cursor: ns-resize;
    top: auto;
    height: var(--resize-border);
  }
  .container .widget .resize.left {
    cursor: ew-resize;
    right: auto;
    width: var(--resize-border);
  }
  .container .widget .resize.right {
    cursor: ew-resize;
    left: auto;
    width: var(--resize-border);
  }
  .container .widget .resize-diagonal {
    position: absolute;
    background-color: transparent;
    width: 25px;
    height: 25px;
    z-index: 11;
    transition: background-color 0.15s ease-in-out;
  }
  .container .widget .resize-diagonal.top-left {
    cursor: nwse-resize;
    top: 0;
    left: 0;
  }
  .container .widget .resize-diagonal.top-right {
    cursor: nesw-resize;
    top: 0;
    right: 0;
  }
  .container .widget .resize-diagonal.bottom-left {
    cursor: nesw-resize;
    bottom: 0;
    left: 0;
  }
  .container .widget .resize-diagonal.bottom-right {
    cursor: nwse-resize;
    bottom: 0;
    right: 0;
  }
`;